module.exports = __webpack_public_path__ + "static/media/PH3800__002_Explore-30sec.1da519ba.mp3";